import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { StyledTextArea, TextAreaContainer } from "./styles";
import { FieldInfo } from "../FieldInfo";
import { useTheme } from "styled-components";
import { Spinner } from "../Spinner";
import { IconExclamation } from "../icons";
export var TextArea = forwardRef(function TextArea(_a, ref) {
    var label = _a.label, info = _a.info, error = _a.error, containerStyles = _a.containerStyles, isLoading = _a.isLoading, register = _a.register, _b = _a.variant, variant = _b === void 0 ? "default" : _b, props = __rest(_a, ["label", "info", "error", "containerStyles", "isLoading", "register", "variant"]);
    var theme = useTheme();
    var isDisabled = props.disabled || isLoading;
    return (_jsxs(TextAreaContainer, { style: containerStyles, children: [label, _jsx(StyledTextArea, __assign({}, props, { "$isLoading": isLoading || !!error, "$hasError": !!error, disabled: isDisabled, variant: variant }, register, { ref: function (e) {
                    if (register) {
                        register.ref(e);
                    }
                    if (ref) {
                        //@ts-ignore
                        ref.current = e;
                    }
                } })), _jsx(FieldInfo, { isError: !!error, style: __assign({}, (isDisabled ? { color: theme.colors.neutral.light } : {})), children: error || info }), isLoading && (_jsx(Spinner, { color: theme.colors.neutral.light, style: {
                    position: "absolute",
                    right: 16,
                    top: 36,
                } })), error && (_jsx(IconExclamation, { style: { position: "absolute", right: 16, top: 36 }, fill: theme.colors.red.default }))] }));
});
//# sourceMappingURL=index.js.map